export default "__VITE_ASSET__qBZMs0Ho__"